import { render, staticRenderFns } from "./ContactHome.vue?vue&type=template&id=5a2050aa&scoped=true"
import script from "./ContactHome.vue?vue&type=script&lang=js"
export * from "./ContactHome.vue?vue&type=script&lang=js"
import style0 from "./ContactHome.vue?vue&type=style&index=0&id=5a2050aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2050aa",
  null
  
)

export default component.exports